<ngx-slick-carousel
  class="carousel"
  #slickModal="slick-carousel"
  *ngIf="items$ | async as items"
  [config]="slickConfig"
>
  <ng-container *ngFor="let item of items; let i = index">
    <div ngxSlickItem *ngIf="item as data" class="slide">
      <div
        class="item"
        [class.outlet]="isOutlet$ | async"
        [class.has-erp-promo]="atLeastOneHasErpPromo && !showSrp"
        [class.has-hybris-promo]="atLeastOneHasHybrisPromo && !showSrp"
      >
        <a tabindex="0" (click)="goToPdp(data, $event, i + 1)">
          <span class="prod-image">
            <cx-media
              [container]="getImageRendition(data?.images?.PRIMARY)"
              format="product"
              [class.is-missing-fish]="businessType === 'fish'"
            ></cx-media>
          </span>
          <span class="prod-sku">
            {{ data.code }}
          </span>
          <span [ngClass]="['prod-name', data?.code]" [class.outlet]="isOutlet$ | async" [innerHTML]="data.name"></span>
          <span class="prod-price">
            <ng-template [ngIf]="!showSrp">
              <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
              <span
                class="p-price"
                [class.erp-promo]="erpPromoValue(data?.code) && erpPromoValue(data?.code) !== '' && isOutlet$ | async"
              >
                <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(data.code); else dealerPriceReady">
                  <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                    <div class="spinner-shimano" *ngIf="this.hasDealerPrice">
                      <div></div>
                    </div>
                    <div
                      class="no-dealer-price no-dealer-price-pcn"
                      *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltip"
                    ></div>
                    <ng-template #noDealerPriceTooltip>
                      <app-tooltip-icon
                        *ngIf="!hasDealerPrice && tooltipIconConfig?.enabled"
                        [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                        dealerPriceIconContainerClass="no-dealer-price-pcn"
                        [uniqueClass]="data?.code"
                        placement="bottom-right"
                        [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                        [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                        [noPointerEventsOnElement]="tooltipIconConfig?.noPointerEventsOnElement"
                        [handleEvents]="tooltipIconConfig?.handleEvents"
                      ></app-tooltip-icon>
                    </ng-template>
                  </ng-container>
                </div>
                <ng-template #dealerPriceReady>
                  {{ dealerPrice(data.code) }}
                  <span class="gst-label" *ngIf="dealerPrice(data.code) && showGstExclusive$ | async">{{
                    'cart.cartItem.gstExclusive' | cxTranslate
                  }}</span>
                </ng-template>
              </span>
            </ng-template>
            <ng-template [ngIf]="showSrp">
              <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
              <span class="p-price"
                >{{ data.srpPrice?.formattedValue }}
                <span class="gst-label" *ngIf="data.srpPrice?.formattedValue && showGstInclusive$ | async">{{
                  'cart.cartItem.gstInclusive' | cxTranslate
                }}</span></span
              >
            </ng-template>
          </span>
          <app-erp-promotional-text
            *ngIf="dealerPrices && !showSrp && isOutlet$ | async"
            class="mt-auto promotional-text"
            [dealerPriceData]="dealerPriceData(data?.code)"
          ></app-erp-promotional-text>
          <app-promotional-text
            *ngIf="dealerPrices && !showSrp && isOutlet$ | async"
            [productCode]="data.code"
            [product]="data"
            [promotionLocation]="'NORMALCAROUSEL'"
            [charactersLimit]="25"
          ></app-promotional-text>
        </a>
      </div>
    </div>
  </ng-container>
</ngx-slick-carousel>
